import { Component, OnInit, Input, ViewContainerRef } from '@angular/core';
import { User } from 'src/app/shared/models/user';
import { UserSessionService } from 'src/app/shared/services/user-session/user-session.service';
import { Messages } from 'src/app/shared/Constants/messages';
import { AlertControllerService } from 'src/app/shared/services/alert-controller/alert-controller.service';
import { HttpRequestService } from 'src/app/shared/services/http-request/http-request.service';
import { ApiRoutingUrl } from 'src/app/shared/Constants/api-routing-url';
import { ChatbotResetLayoutService } from '../../../services/sabis-chatbot/chatbot-reset-layout.service';

@Component({
    selector: 'app-user-info',
    templateUrl: './user-info.component.html',
    styleUrls: ['./user-info.component.scss'],
    standalone: true
})
export class UserInfoComponent implements OnInit {
  @Input() user: User;
  @Input() rightPosition: string;

  constructor( 
    private _alertCtrl: AlertControllerService,
    private _userSessionService: UserSessionService,
    private viewContainerRef: ViewContainerRef,
    private _http: HttpRequestService,
    private _chatbotResetStyles: ChatbotResetLayoutService
  ) {}

  ngOnInit(): void {}

  public onLogoutButtonClicked(): void {
    this._alertCtrl
      .presentConfirm(
        Messages.LOG_OUT_CONFIRMATION,
        this.viewContainerRef,
        Messages.LOG_OUT_CONFIRMATION_title
      )
      .subscribe(confirmed => {
        if (confirmed) {
          //used to reset styles after lougout when chatbot is still open
          this._chatbotResetStyles.resetChatbotStyles();

          this._http.get(ApiRoutingUrl.logout).subscribe();
          this._userSessionService.onLogout.emit();
        }
      });
  }
}
